/**
 * EXTENSION — the browser-extension download + live-status page (route `/extension`).
 *
 * Renders inside the marketing LayoutDefault. Self-styled (inline) so it doesn't depend on the marketing
 * SCSS. Detects the current browser + whether the extension is already installed (adr/0005 handshake via
 * components/ExtensionStatus), and offers per-browser install buttons.
 */
import React from 'react';
import { useExtension, ExtensionDownloads } from '../components/ExtensionStatus';

const card = {
  maxWidth: 720,
  margin: '0 auto',
  background: '#0d1220',
  border: '1px solid rgba(255,255,255,.08)',
  borderRadius: 20,
  padding: '36px 28px',
  color: '#eef2ff',
};

export default function Extension() {
  const { present, info, today } = useExtension();
  const tried = today ? today.attempts.adult + today.attempts.custom : null;

  return (
    <section style={{ padding: '56px 20px 80px', background: '#080b16', minHeight: '70vh' }}>
      <div style={card}>
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              width: 64,
              height: 64,
              margin: '0 auto 18px',
              borderRadius: 18,
              display: 'grid',
              placeItems: 'center',
              fontSize: 30,
              background: 'rgba(255,255,255,.06)',
              border: '1px solid rgba(255,255,255,.12)',
            }}
            aria-hidden="true"
          >
            🛡️
          </div>
          <h1 style={{ fontSize: 28, margin: '0 0 8px', letterSpacing: '-0.01em' }}>Keep Me Out for your browser</h1>
          <p style={{ color: '#b9c2e0', margin: '0 auto 24px', maxWidth: 520, lineHeight: 1.5 }}>
            Block adult &amp; custom sites, and see how often you try to reach them — right in your browser.
            On-device by default; nothing leaves until you opt in.
          </p>

          {present ? (
            <div
              role="status"
              style={{
                display: 'inline-block',
                padding: '12px 18px',
                borderRadius: 14,
                background: 'rgba(52,211,153,.12)',
                border: '1px solid rgba(52,211,153,.4)',
                color: '#86efac',
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              ✓ Installed &amp; connected in this browser ({info.browser})
              {tried != null && (
                <div style={{ color: '#cbd5e1', fontWeight: 500, fontSize: 13, marginTop: 4 }}>
                  Today: {tried} tried · {today.blocked} blocked · {today.resisted} resisted
                </div>
              )}
            </div>
          ) : (
            <p style={{ color: '#8b93b7', fontSize: 14, marginBottom: 8 }}>
              Not detected in this browser yet — pick your browser below.
            </p>
          )}
        </div>

        <div style={{ marginTop: 24 }}>
          <ExtensionDownloads />
        </div>

        <p style={{ color: '#6b7398', fontSize: 12.5, textAlign: 'center', marginTop: 22, lineHeight: 1.6 }}>
          Honest coverage: the extension covers this browser. Other browsers, private windows without
          extension access, and DNS-level tunnels are detected and flagged, not silently blocked — the Keep
          Me Out phone app covers the layers a browser can't.
        </p>
      </div>
    </section>
  );
}
